import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  CheckoutBasketPartialState,
  CheckoutBasketSelectors,
} from '@common/data-access-checkout-basket';
import { BuildConfigService } from '@common/util-foundation';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { tap, withLatestFrom } from 'rxjs/operators';
import * as PersonalDetailsActions from './personal-details.actions';
import { PersonalDetailsPartialState } from './personal-details.reducer';

@Injectable()
export class PersonalDetailsEffects {
  updatePersonalDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PersonalDetailsActions.proceedToPayment),
        withLatestFrom(
          this.store.pipe(
            select(CheckoutBasketSelectors.isDirectDebitOnlyPaymentOption)
          )
        ),
        tap(([, isDirectDebitOnlyPaymentOption]) =>
          isDirectDebitOnlyPaymentOption
            ? this.router.navigateByUrl(
                this.buildConfig.config.checkoutDirectDebitPage
              )
            : this.router.navigateByUrl(
                this.buildConfig.config.selectPaymentPage
              )
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private buildConfig: BuildConfigService,
    private store: Store<
      PersonalDetailsPartialState & CheckoutBasketPartialState
    >,
    private router: Router
  ) {}
}
